import {createFileRoute} from "@tanstack/react-router";
import {offerHistoryMessages} from "../../-messages/offer-history.messages";
import {OfferHistoryPage} from "./-page/offer-history.page";
import {OfferHistoryPending} from "./-page/offer-history.pending";
import {offerHistorySearchSchema} from "./-types";

export const Route = createFileRoute("/_app/sales/offers/$offerId/history/")({
  component: RouteComponent,
  pendingComponent: OfferHistoryPending,
  validateSearch: (search) => offerHistorySearchSchema.parse(search),
  staticData: {meta: {labelDescriptor: offerHistoryMessages.title}},
});
function RouteComponent() {
  const {offerId} = Route.useParams();
  return <OfferHistoryPage offerId={offerId} />;
}
